import Logo from "./Logo";

export const Footer = () => (
  <footer className="relative border-t border-ink-line bg-ink-soft/60 py-14" data-testid="footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <Logo />
          <p className="mt-4 text-sm text-mist leading-relaxed max-w-xs">
            Giulia, l'IA opérateur pour tous : de la veille au rendez-vous,
            vous validez, elle exécute.
          </p>
        </div>

        <div data-testid="footer-legal">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-viol-soft mb-4">
            Mentions légales
          </p>
          <p className="text-sm text-mist/80 leading-relaxed">
            GiulIATeck — [raison sociale, SIRET et adresse à compléter].
            <br />
            Directeur de publication : [à compléter].
            <br />
            Hébergeur : [à compléter].
          </p>
        </div>

        <div className="md:text-right">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-viol-soft mb-4">
            Contact
          </p>
          <a
            href="https://wa.me/33660705559"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="text-sm text-mist hover:text-white transition-colors"
          >
            WhatsApp : +33 6 60 70 55 59
          </a>
          <p className="mt-4 text-xs text-mist/50">
            <a
              href="https://pepe-avs.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-pepe-avs-link"
              className="hover:text-mist transition-colors"
            >
              un projet de PEPE AVS
            </a>
          </p>
        </div>
      </div>

      <div className="mt-12 border-t border-ink-line pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-mist/60">© {new Date().getFullYear()} GiulIATeck. Tous droits réservés.</p>
        <p className="font-mono text-[11px] text-mist/40 uppercase tracking-[0.2em]">Vous validez, elle exécute</p>
      </div>
    </div>
  </footer>
);

export default Footer;
